import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requirePermissionOrRedirect } from '@/lib/auth/require-permission';
import { MATERIAL_PERM } from '@/lib/auth/material-permissions';

const ComposeJobPage = lazy(() =>
  import('@/pages/ads/material-process/compose-job-page').then((m) => ({
    default: m.ComposeJobPage,
  })),
);

export const Route = createFileRoute('/_app/ads/material-process/new')({
  // 建任务单独收口：只有 process:read 的人进得了列表，但提交不了
  beforeLoad: requirePermissionOrRedirect(MATERIAL_PERM.processEdit, '/ads/material-process'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <ComposeJobPage />
    </Suspense>
  ),
});
